module.exports = __webpack_public_path__ + "assets/cecfb9393513ab2db1d7c6d70911381d.mp3";